var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoPaperPlane = function SvgMoPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 53,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mo-paper-plane_svg__a)",
    d: "M19.207 52.764 34.432 39.29l6.902 7.84c.569.647 1.643.249 1.643-.608V32.197a.92.92 0 0 0-.377-.743l-28.574-21.07c-.12-.088-.009-.273.128-.21l35.593 16.451a.94.94 0 0 0 .767.012l16.92-7.209c.815-.347.73-1.516-.126-1.745L1.18.033C.458-.16-.19.525.051 1.226l17.645 51.147a.94.94 0 0 0 1.51.39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mo-paper-plane_svg__a",
    x1: 0,
    x2: 51.396,
    y1: 0,
    y2: 65.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgMoPaperPlane;